import { FactAdder } from '@/new/components/fact-adder';
import { Icon } from '@/new/components/icon';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/new/components/shadcn/dialog';

interface AddFactDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  handleNewFactCreated: () => void;
  docId?: string;
}

export const AddFactDialog = ({ docId, isOpen, onOpenChange, handleNewFactCreated }: AddFactDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--plus-circle" />
            Add Fact
          </DialogTitle>
        </DialogHeader>

        <FactAdder docId={docId} handleNewFactCreated={handleNewFactCreated} />
      </DialogContent>
    </Dialog>
  );
};
